import React, {useState} from 'react'
import { GoogleMap, withGoogleMap, withScriptjs, Marker, InfoWindow } from 'react-google-maps'
import restaurantList from './../restaurants/restaurantsList'
import restaurantListHe from './../restaurants/restaurantsListHe'

function GetMap() {
    const [selectedRest, setSelectedRest] = useState(null)
    // If it is an English page, so render it in english
    if (window.location.href.includes('/en')) { 
        return (
            <GoogleMap defaultZoom={7} defaultCenter={{lat: 52.382151, lng: -1.987970}}>

            {restaurantList.map((restaurant, index) =>
                <Marker 
                key={index} 
                position={{lat: restaurant.coordinates[0], lng: restaurant.coordinates[1]}}
                onClick={() => setSelectedRest(restaurant)}
                icon={{url: "/assets/contact/restauranticon.png", scaledSize: new window.google.maps.Size(30, 30)}}
                />
            )}

            {selectedRest && (
                <InfoWindow position={{lat: selectedRest.coordinates[0], lng: selectedRest.coordinates[1]}} onCloseClick={() => setSelectedRest(null)}>
                <div style={{paddingLeft: '5px'}}>
                    <div style={{textAlign: 'center', fontSize: '14px', paddingBottom: '5px'}}><b>Restaurant Details</b></div>
                    <div style={{marginBottom: '5px'}}><u><b>Name:</b></u>  {selectedRest.title}</div>
                    <div style={{marginBottom: '5px'}}><u><b>Address:</b></u>  {selectedRest.addressNoHTML}</div>
                    <div><u><b>Phone:</b></u> {selectedRest.phoneNumber}</div>
                </div>
                </InfoWindow>
            )}

            </GoogleMap>
        );
    }
    // Else render it in Hebrew
    return (
        <GoogleMap defaultZoom={7} defaultCenter={{lat: 52.382151, lng: -1.987970}} class="hebrew">
    
                {restaurantListHe.map((restaurant, index) =>
                    <Marker 
                    key={index} 
                    position={{lat: restaurant.coordinates[0], lng: restaurant.coordinates[1]}}
                    onClick={() => setSelectedRest(restaurant)}
                    icon={{url: "/assets/contact/restauranticon.png", scaledSize: new window.google.maps.Size(30, 30)}}
                    />
                )}
    
                {selectedRest && (
                    <InfoWindow position={{lat: selectedRest.coordinates[0], lng: selectedRest.coordinates[1]}} onCloseClick={() => setSelectedRest(null)}>
                    <div style={{paddingLeft: '5px', fontSize: '15px'}}>
                        <div style={{textAlign: 'center', fontSize: '16px', paddingBottom: '5px'}}><b>פרטי המסעדה</b></div>
                        <div style={{marginBottom: '5px'}}><u><b>שם:</b></u>  {selectedRest.title}</div>
                        <div style={{marginBottom: '5px'}}><u><b>כתובת:</b></u>  {selectedRest.addressNoHTML}</div>
                        <div><u><b>פלאפון:</b></u> <span className="numChars">{selectedRest.phoneNumber}</span></div>
                    </div>
                    </InfoWindow>
                )}
    
        </GoogleMap>
    );
}

const WrappedMap = withScriptjs(withGoogleMap(GetMap));


function Map() {
    if (navigator.userAgent === "ReactSnap") return null;
    return (
            <WrappedMap
            googleMapURL={'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places&key=AIzaSyDDrcqzef-g6UoHT4nkQKfuRCOR-TjS15I'}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div id="containerMap"/>}
            mapElement={<div style={{ height: `100%` }} />}
            /> 
    )
}

export default Map
